export const SET_ROUTE = 'SET_ROUTE';
export const SET_ROUTE_ERROR = 'SET_ROUTE_ERROR';
export const SET_CAN_REFRESH = 'SET_CAN_REFRESH';
export const SET_ROUTE_LOADING = 'SET_ROUTE_LOADING';
